import { render } from "./index.html?vue&type=template&id=5caf189f&scoped=true&ts=true"
import script from "./index.ts?vue&type=script&lang=ts"
export * from "./index.ts?vue&type=script&lang=ts"

import "./index.css?vue&type=style&index=0&id=5caf189f&scoped=true&lang=css"

import exportComponent from "E:\\yl\\web\\lvxingshibie-backend\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caf189f"]])

export default __exports__